import classNames from './TheButton.module.scss';
import classes from 'classnames';
import { useAppSelector } from '@/store';
import SVG from 'react-inlinesvg';
import { ButtonHTMLAttributes } from 'react';

import rightArrow from '@/assets/svg/right-arrow-large.svg';
import { authSelector } from '@/store/reducers/auth';
import { rtlLangs } from '@/school-management/context/LocaleContext';

interface TheButtonProps {
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  text: string;
  description?: string;
  descriptionClassName?: string;
  className?: string;
  plain?: boolean;
  showArrow?: boolean;
  shouldRecolor?: boolean;
  disabled?: boolean;
  allowDynamicDirection?: boolean;
  ariaLabel?: string;
  icon?: string;
  emitOnClick?: () => void;
}

const TheButton = ({
  type = 'button',
  text,
  description,
  descriptionClassName,
  className,
  plain = false,
  showArrow = false,
  shouldRecolor = true,
  disabled = false,
  allowDynamicDirection = true,
  ariaLabel,
  icon,
  emitOnClick,
}: TheButtonProps) => {
  // const interfaceLanguage = useAppSelector(interfaceLanguageSelector);
  const interfaceLanguage = 'en';
  const { user } = useAppSelector(authSelector);

  return (
    <button
      type={type}
      className={classes(
        classNames.theButton,
        {
          [classNames[`theButton-ltr`]]: allowDynamicDirection,
        },
        { [classNames.plain]: plain },
        className
      )}
      onClick={emitOnClick}
      disabled={disabled}
      aria-label={ariaLabel || text}
    >
      {icon && <SVG src={icon} className={classes()} />}
      {description && <span className={descriptionClassName}>{description}</span>}
      <span>{text}</span>
      {showArrow && (
        <SVG
          src={rightArrow}
          className={classes()}
          style={{
            transform: `rotate(${allowDynamicDirection ? '180deg' : '0deg'})`,
          }}
        />
      )}
    </button>
  );
};

export default TheButton;
